import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { store } from "@root/store";
import { doc, getDoc, getDocs, onSnapshot, query, where } from "firebase/firestore";
import { following, followers, profiles, projects, projectsCount, profileStars, tags } from "@config/firestore";
import { downloadProjectOnce, storeProjectLocally, unsetProject } from "@comp/projects/actions";
import { convertProjectSnapToProject } from "@comp/projects/utils";
import { storeUserProfile, storeProfileProjectsCount, storeProfileStars } from "./actions";
import { UPDATE_PROFILE_FOLLOWING, UPDATE_PROFILE_FOLLOWERS } from "./types";
import { listifyObject } from "@root/utils";
import { assoc, descend, difference, filter, isEmpty, keys, map, pathOr, pipe, prop, propEq, propOr, sort } from "ramda";
export var subscribeToProfile = function subscribeToProfile(profileUid, dispatch) {
    var unsubscribe = onSnapshot(doc(profiles, profileUid), function (profile) {
        var profileData = profile.data();
        if (profileData.userJoinDate) {
            profileData.userJoinDate = profileData.userJoinDate.toMillis();
        }
        dispatch(storeUserProfile(profileData, profileUid));
    }, function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToFollowing = function subscribeToFollowing(profileUid, dispatch) {
    var unsubscribe = onSnapshot(doc(following, profileUid), /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(followingReference) {
            var state, userProfileData, userProfileDataSorted, userProfileUids, cachedProfileUids, missingProfileUids, missingProfiles;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = store.getState();
                            userProfileData = followingReference.data();
                            userProfileDataSorted = sort(descend(propOr(Number.NEGATIVE_INFINITY, "val")), listifyObject(userProfileData || {}));
                            userProfileUids = map(prop("key"), userProfileDataSorted);
                            cachedProfileUids = keys(state.ProfileReducer.profiles);
                            missingProfileUids = difference(userProfileUids, cachedProfileUids);
                            _context2.next = 8;
                            return Promise.all(missingProfileUids.map(/*#__PURE__*/ function () {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(followingProfileUid) {
                                    var profPromise, profileData;
                                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                                        while (1)
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return getDoc(doc(profiles, followingProfileUid));
                                                case 2:
                                                    profPromise = _context.sent;
                                                    profileData = profPromise.exists() ? profPromise.data() : {
                                                        displayName: "Deleted user"
                                                    };
                                                    if (profileData.userJoinDate) {
                                                        profileData.userJoinDate = profileData.userJoinDate.toMillis();
                                                    }
                                                    return _context.abrupt("return", profileData);
                                                case 6:
                                                case "end":
                                                    return _context.stop();
                                            }
                                    }, _callee);
                                }));
                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }()));
                        case 8:
                            missingProfiles = _context2.sent;
                            dispatch({
                                type: UPDATE_PROFILE_FOLLOWING,
                                profileUid: profileUid,
                                userProfiles: missingProfiles,
                                userProfileUids: userProfileUids
                            });
                        case 10:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }(), function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToFollowers = function subscribeToFollowers(profileUid, dispatch) {
    var unsubscribe = onSnapshot(doc(followers, profileUid), /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(followersReference) {
            var state, userProfileData, userProfileDataSorted, userProfileUids, cachedProfileUids, missingProfileUids, missingProfiles;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            state = store.getState();
                            userProfileData = followersReference.data();
                            userProfileDataSorted = sort(descend(propOr(Number.NEGATIVE_INFINITY, "val")), listifyObject(userProfileData || {}));
                            userProfileUids = map(prop("key"), userProfileDataSorted);
                            cachedProfileUids = keys(state.ProfileReducer.profiles);
                            missingProfileUids = difference(userProfileUids, cachedProfileUids);
                            _context4.next = 8;
                            return Promise.all(missingProfileUids.map(/*#__PURE__*/ function () {
                                var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(followerProfileUid) {
                                    var profPromise, profileData;
                                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                                        while (1)
                                            switch (_context3.prev = _context3.next) {
                                                case 0:
                                                    _context3.next = 2;
                                                    return getDoc(doc(profiles, followerProfileUid));
                                                case 2:
                                                    profPromise = _context3.sent;
                                                    profileData = profPromise.exists() ? profPromise.data() : {
                                                        displayName: "Deleted user"
                                                    };
                                                    if (profileData.userJoinDate) {
                                                        profileData.userJoinDate = profileData.userJoinDate.toMillis();
                                                    }
                                                    return _context3.abrupt("return", profileData);
                                                case 6:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                    }, _callee3);
                                }));
                                return function (_x4) {
                                    return _ref4.apply(this, arguments);
                                };
                            }()));
                        case 8:
                            missingProfiles = _context4.sent;
                            dispatch({
                                type: UPDATE_PROFILE_FOLLOWERS,
                                profileUid: profileUid,
                                userProfiles: missingProfiles,
                                userProfileUids: userProfileUids
                            });
                        case 10:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4);
        }));
        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }(), function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToProjectsCount = function subscribeToProjectsCount(profileUid, dispatch) {
    var unsubscribe = onSnapshot(doc(projectsCount, profileUid), function (projectsCount) {
        var projectsCountData = projectsCount.data();
        if (projectsCountData) {
            var projectsCount_ = {
                public: projectsCountData.public || 0,
                all: projectsCountData.all || 0
            };
            projectsCountData && dispatch(storeProfileProjectsCount(projectsCount_, profileUid));
        }
    }, function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToProfileStars = function subscribeToProfileStars(profileUid, dispatch) {
    var unsubscribe = onSnapshot(doc(profileStars), function (starsReference) {
        var starsData = starsReference.data();
        if (!starsData) {
            return;
        }
        var state = store.getState();
        var starredProjects = keys(starsData);
        var cachedProjects = keys(state.ProjectsReducer.projects);
        var missingProjects = difference(starredProjects, cachedProjects);
        missingProjects.forEach(function (projectUid) {
            return dispatch(downloadProjectOnce(projectUid));
        });
        dispatch(storeProfileStars(starsData, profileUid));
    }, function (error) {
        return console.error(error);
    });
    return unsubscribe;
};
export var subscribeToProfileProjects = function subscribeToProfileProjects(profileUid, isProfileOwner, dispatch) {
    var unsubscribe = onSnapshot(isProfileOwner ? query(projects, where("userUid", "==", profileUid)) : query(projects, where("public", "==", true)
    // query(
    //     query(projects, where("userUid", "==", profileUid)),
    // )
    ), /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(projectSnaps) {
            var currentProfileProjects, projectsDeleted;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1)
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            currentProfileProjects = pipe(pathOr([], ["ProjectsReducer", "projects"]), filter(propEq("userUid", profileUid)))(store.getState());
                            projectsDeleted = difference(keys(currentProfileProjects).sort(), map(prop("id"), projectSnaps.docs).sort());
                            if (!projectSnaps.empty) {
                                Promise.all(projectSnaps.docs.map(/*#__PURE__*/ function () {
                                    var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(projSnap) {
                                        var projTags, proj;
                                        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                            while (1)
                                                switch (_context5.prev = _context5.next) {
                                                    case 0:
                                                        _context5.next = 2;
                                                        return getDocs(query(tags, where(projSnap.id, "==", profileUid))).then(function (d) {
                                                            return d.docs.map(prop("id"));
                                                        });
                                                    case 2:
                                                        projTags = _context5.sent;
                                                        _context5.next = 5;
                                                        return convertProjectSnapToProject(projSnap);
                                                    case 5:
                                                        proj = _context5.sent;
                                                        return _context5.abrupt("return", assoc("tags", projTags, proj));
                                                    case 7:
                                                    case "end":
                                                        return _context5.stop();
                                                }
                                        }, _callee5);
                                    }));
                                    return function (_x6) {
                                        return _ref6.apply(this, arguments);
                                    };
                                }())).then(function (localProjects) {
                                    dispatch(storeProjectLocally(localProjects));
                                });
                            }
                            if (!isEmpty(projectsDeleted)) {
                                projectsDeleted.forEach(/*#__PURE__*/ function () {
                                    var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(projectUid) {
                                        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                                            while (1)
                                                switch (_context6.prev = _context6.next) {
                                                    case 0:
                                                        _context6.next = 2;
                                                        return dispatch(unsetProject(projectUid));
                                                    case 2:
                                                    case "end":
                                                        return _context6.stop();
                                                }
                                        }, _callee6);
                                    }));
                                    return function (_x7) {
                                        return _ref7.apply(this, arguments);
                                    };
                                }());
                            }
                        case 4:
                        case "end":
                            return _context7.stop();
                    }
            }, _callee7);
        }));
        return function (_x5) {
            return _ref5.apply(this, arguments);
        };
    }());
    return unsubscribe;
};
